import * as Models from "../.";
export interface ISolarAccountResponse {
  solarSearchAccounts: Models.Customer.SolarSearchAccount.SolarSearchAccount[];
  count: number;
}

export class SolarAccountResponse implements ISolarAccountResponse {
  solarSearchAccounts: Models.Customer.SolarSearchAccount.SolarSearchAccount[];
  count: number;
}
